// src/components/layout/FAB.jsx
// FAB yang tetap di dalam shell (absolute, bukan fixed)

import React, { useState } from 'react';
import { Plus, Clipboard, Camera, Mic, X } from 'lucide-react';

export default function FAB({ onPaste, onCamera, onVoice }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    /*
      PERBAIKAN:
      - Ganti `fixed` ke `absolute` agar tetap dalam shell container
      - Parent (App.jsx shell) sudah `position: relative` + `overflow-hidden`
      - z-index lebih rendah dari FloatingNav agar tidak menutupi
    */
    <div
      className="
        absolute
        bottom-24 right-4
        z-40 no-print
      "
      style={{
        // Naikkan di atas FloatingNav (~80px + safe area)
        // Tapi tetap di dalam shell
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      {isOpen && (
        <>
          {/* Backdrop Overlay */}
          <div
            className="
              fixed inset-0
              bg-black/30
              backdrop-blur-sm
              z-30
              animate-fade-in
            "
            onClick={() => setIsOpen(false)}
          />

          {/* Mini Menu */}
          <div className="absolute bottom-16 right-0 z-40 space-y-3">
            {/* Paste */}
            <div className="flex items-center gap-2 animate-slide-up">
              <span className="
                bg-white dark:bg-slate-800
                text-slate-800 dark:text-slate-100
                text-[10px] font-bold
                px-2.5 py-1 rounded-xl
                shadow-soft
                whitespace-nowrap
              ">
                Tempel
              </span>
              <button
                onClick={() => { onPaste?.(); setIsOpen(false); }}
                className="
                  w-12 h-12
                  bg-sky-500 hover:bg-sky-600
                  rounded-2xl
                  flex items-center justify-center
                  shadow-lg shadow-sky-500/30
                  active:scale-95 transition-all
                "
              >
                <Clipboard className="w-5 h-5 text-white" />
              </button>
            </div>

            {/* Camera */}
            <div className="flex items-center gap-2 animate-slide-up" style={{ animationDelay: '0.05s' }}>
              <span className="
                bg-white dark:bg-slate-800
                text-slate-800 dark:text-slate-100
                text-[10px] font-bold
                px-2.5 py-1 rounded-xl
                shadow-soft
                whitespace-nowrap
              ">
                Kamera OCR
              </span>
              <button
                onClick={() => { onCamera?.(); setIsOpen(false); }}
                className="
                  w-12 h-12
                  bg-purple-500 hover:bg-purple-600
                  rounded-2xl
                  flex items-center justify-center
                  shadow-lg shadow-purple-500/30
                  active:scale-95 transition-all
                "
              >
                <Camera className="w-5 h-5 text-white" />
              </button>
            </div>

            {/* Voice */}
            <div className="flex items-center gap-2 animate-slide-up" style={{ animationDelay: '0.1s' }}>
              <span className="
                bg-white dark:bg-slate-800
                text-slate-800 dark:text-slate-100
                text-[10px] font-bold
                px-2.5 py-1 rounded-xl
                shadow-soft
                whitespace-nowrap
              ">
                Voice
              </span>
              <button
                onClick={() => { onVoice?.(); setIsOpen(false); }}
                className="
                  w-12 h-12
                  bg-amber-500 hover:bg-amber-600
                  rounded-2xl
                  flex items-center justify-center
                  shadow-lg shadow-amber-500/30
                  active:scale-95 transition-all
                "
              >
                <Mic className="w-5 h-5 text-white" />
              </button>
            </div>
          </div>
        </>
      )}

      {/* Tombol Utama FAB */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Menu Aksi Cepat"
        className={`
          w-14 h-14 rounded-2xl
          flex items-center justify-center
          shadow-lg
          transition-all duration-300 active:scale-90
          ${isOpen
            ? 'bg-red-500 hover:bg-red-600 shadow-red-500/40 rotate-45'
            : 'bg-gradient-to-br from-green-500 to-green-600 shadow-green-500/40 hover:shadow-green-500/50'
          }
        `}
      >
        {isOpen
          ? <X className="w-6 h-6 text-white" strokeWidth={2.5} />
          : <Plus className="w-6 h-6 text-white" strokeWidth={2.5} />
        }
      </button>
    </div>
  );
}